import React from 'react';
import { CheckIcon } from './data';
import { SectionLabel, SumRow } from './components';
import appStoreBadge from '../../images/app-store-badge.svg';
import googlePlayBadge from '../../images/google-play-badge.svg';

export default function QuoteConfirmation(props) {
  var email = props.email;
  var planName = props.planName;
  var summaryCoverage = props.summaryCoverage;
  var destSummary = props.destSummary;
  var travelersCount = props.travelersCount;
  var grand = props.grand;
  var canShowPricing = props.canShowPricing;
  var money0 = props.money0;
  var onReset = props.onReset;

  return (
    <div className='cap-confirm'>
      <div className='cap-confirm__head'>
        <div className='cap-confirm__deco' />
        <span className='cap-confirm__check'>
          <CheckIcon size={32} color='#fff' />
        </span>
        <h1 className='cap-h1 cap-h1--confirm'>You're covered.</h1>
        <p className='cap-confirm__lead'>
          A confirmation email is on its way to{' '}
          <strong className='cap-confirm__lead-strong'>{email || 'your email'}</strong>. Welcome to CAP.
        </p>
      </div>
      <div className='cap-confirm__body'>
        <div className='cap-confirm__section'>
          <SectionLabel>Order summary</SectionLabel>
          <div className='cap-confirm__summary'>
            <SumRow label='Plan' value={planName} />
            <SumRow label='Coverage' value={summaryCoverage} />
            <SumRow label='Destinations' value={destSummary} />
            <SumRow label='Travelers' value={travelersCount === 1 ? '1 (just you)' : travelersCount + ' people'} />
            <div className='cap-confirm__total-row'>
              <span className='cap-confirm__total-label'>Total paid</span>
              <span className='cap-confirm__total-value'>{canShowPricing ? money0(grand) : '—'}</span>
            </div>
          </div>
        </div>
        <div className='cap-app-promo'>
          <div className='cap-app-promo__title'>Download the CAP App to activate coverage</div>
          <p className='cap-app-promo__text'>
            Your protection lives in the app — risk alerts, destination intel, and the one-touch ASSIST
            button. Log in with{' '}
            <strong className='cap-app-promo__text-strong'>{email || 'your email'}</strong>.
          </p>
          <div className='cap-store-badges'>
            <a target="_blank" rel="noopener noreferrer" href='https://apps.apple.com/us/app/cap-advantage/id1484774309'>
              <img src={appStoreBadge} alt="Download on the App Store" style={{ height: '44px' }} />
            </a>
            <a target="_blank" rel="noopener noreferrer" href='https://play.google.com/store/apps/details?id=com.focuspoint.capadvantage'>
              <img src={googlePlayBadge} alt="Get it on Google Play" style={{ height: '44px' }} />
            </a>
          </div>
        </div>
        <button
          type='button'
          onClick={onReset}
          className='cap-newquote-btn'
        >
          ← Start a new quote
        </button>
      </div>
    </div>
  );
}
